export function createMnemonicResource(entropy: number) {
  let status = "pending";
  let result: string[] = [];
  let error: Error | undefined = undefined;

  const suspender = import("@scure/bip39")
    .then(async (bip39) => {
      const { wordlist } = await import("@scure/bip39/wordlists/english");
      const mnemonic = bip39.generateMnemonic(wordlist, entropy);
      result = mnemonic.split(" ");
      status = "success";
      return result;
    })
    .catch((e) => {
      error = e;
      status = "error";
      throw e;
    });

  return {
    read() {
      if (status === "pending") {
        throw suspender;
      }
      if (status === "error") {
        throw error;
      }
      return result;
    },
  };
}
